// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 33 ? "widgets" : chunkId) + "." + {"33":"08ff0212","268":"ecd2ef4d","647":"7cf54f00"}[chunkId] + ".js";
};